<script>
import Footer from "@/components/footer";
import modalMd from "@/pages/common/modalMd";
import modalLg from "@/pages/common/modalLg";

// 초기세팅
function initialState() {
  return {
    login: {
      level: 0,
      nick: "",
      isLogin: false,
      email: "",
    },
  };
}

export default {
  components: {
    Footer,
    "modalMd" : modalMd,
    "modalLg" : modalLg,
  },
  data() {
    return initialState();
  },
  computed: {
  },
  methods: {
    // 토큰
    getTokenInfo() {
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      // expire 시간을 체크하여 삭제할 때 설정된 시간이 지나면 'user' 키를 삭제
      // 로컬스토리지 값 가져오자
      if (getLocalStorage) {
        if (getLocalStorage.expire) {
          const currentTime = new Date().getTime();
          const expireTime = parseInt(getLocalStorage.expire);
          // 종료시간 지났으면 로그아웃처리
          if (currentTime > expireTime) {
            localStorage.removeItem('user');
            this.login.nick = ''
            this.login.level = 0
            this.login.isLogin = false
            this.login.email = ''
          } else { // 종료시간 전이면 종료시간 갱신
            // 사용자가 액세스 토큰을 사용할 때마다 expire 시간을 갱신 6시간은 3 * 60 * 60 * 1000 
            const updatedExpireTime = currentTime + (6 * 60 * 60 * 1000 );
            getLocalStorage.expire = updatedExpireTime.toString();
            localStorage.setItem('user', JSON.stringify(getLocalStorage));
          }
        }
        this.$store.commit("setAuthIdx", getLocalStorage.idx)
        this.$store.commit("setAuthAccessToken", getLocalStorage.access_token)
        this.$store.commit("setAuthNick", getLocalStorage.nick)
        this.$store.commit("setAuthLevel", getLocalStorage.level)
        this.$store.commit("setAuthEmail", getLocalStorage.email)
        this.$store.commit("setAuthIsLogin", true)
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.login.isLogin = true
        this.login.email = getLocalStorage.email
      }
    },
  },
  mounted() {
    this.getTokenInfo();
    // 로딩바
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";
      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 250);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
};
</script>

<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="card">
          <div class="card-body spinner-chase text-primary">
            <div class="text-center h4 mb-2">잠시만 기다려주세요</div>
            <div class="d-flex justify-content-center mb-3">
              <b-spinner label="기다려 주세요..."></b-spinner>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Begin page -->
    <div id="layout-wrapper">
      <modalMd></modalMd>
      <modalLg></modalLg>
      <!--
      <sidebarNormal></sidebarNormal>
      <sidebarOrders></sidebarOrders>
      <sidebarLeft></sidebarLeft>
      <HorizontalTopbar :type="topbar" :width="layoutWidth" />
      <modal2xl></modal2xl>
      <modalXl></modalXl>
      <modalLg></modalLg>
      <modalMd></modalMd>
      <modalSm></modalSm>
      <underSide></underSide>
      <sidebarRight></sidebarRight>
      -->
      <slot />
      <Footer :loginInfo="login" />
    </div>
  </div>
</template>
